import React from "react";
import NoDataTable from "@/shared/components/ui/NoDataView/NoDataTable";
import UploadModal from "@/shared/components/ui/Upload/UploadModal";
import NoDataFound from "@/shared/components/ui/NoDataView/NoDataFound";
import Loader from "@/shared/components/ui/Loaders/Loader";

const ContactEmptyStates = ({
  viewState,
  show,
  setShow,
  onImport,
  searchValue,
  appliedFilters,
  onAddContactClick,
  onRelevantAddClick,
}) => {
  if (viewState === "LOADING") {
    return (
      <div className="w-full h-[calc(100dvh-124px)] flex items-center justify-center">
        <Loader text="Loading contacts..." />
      </div>
    );
  }

  if (viewState === "EMPTY_INITIAL") {
    return (
      <div className="w-full relative h-[calc(100dvh-124px)]">
        <NoDataTable />
        <UploadModal
          show={show}
          variant="contacts"
          onClose={() => {}}
          onImport={onImport}
          onAddContactClick={onAddContactClick}
          onRelevantAddClick={onRelevantAddClick}
          bgBlur={false}
          close={false}
        />
      </div>
    );
  }

  if (viewState === "EMPTY_SEARCH") {
    return (
      <NoDataFound
        title="No Contacts Found"
        description={`No contacts found for "${searchValue}"`}
        searchValue={searchValue}
      />
    );
  }

  if (viewState === "EMPTY_FILTERS") {
    return (
      <NoDataFound
        title="No Contacts Found"
        description="No contacts match the applied filters"
        searchValue={
          Object.keys(appliedFilters).length > 0
            ? Object.values(appliedFilters).join(", ")
            : ""
        }
      />
    );
  }

  return null;
};

export default ContactEmptyStates;
